import { evaluateMTF } from "./mtfUtils";

export const getDisplayTypeWithContent = (answerDetails) => {
    let values = []
    const {options} = answerDetails;
    if (options && Object.keys(options).length && options.values) {
        values = options.values
    }

    if (answerDetails.hasOwnProperty('code')) {
        return { type: 'code', content: answerDetails.code }
    }
    if (answerDetails.hasOwnProperty('image')) {
        return { type: 'image', content: answerDetails.image }
    }
    if (answerDetails.hasOwnProperty('text')) {
        return { type: 'text', content: answerDetails.text }
    }
    if (answerDetails.hasOwnProperty('youtubeVideo')) {
        return { type: 'youtubeVideo', content: answerDetails.youtubeVideo }
    }
    if (answerDetails.hasOwnProperty('video')) {
        return { type: 'video', content: answerDetails.video }
    }
    if (answerDetails.hasOwnProperty('audio')) {
        return { type: 'audio', content: answerDetails.audio }
    }

    return { type: 'text', content: '' }
}

export const getOptionValuesFromAnswer = (answerDetails) => {
    let {options} = answerDetails;

    if (options && Object.keys(options).length) {
        return options.values;
    }

    return []
}

export const getAnswerFromSelected = (selectedAnswer) => {
    let answerArray = Object.values(selectedAnswer);
    return selectedAnswer = answerArray.length ? answerArray[0] : {};
}

export const getAnswerKeyfromQuestion = (questionDetails={}) => {
    let {options} = questionDetails.answerDetails || {},
        answerKey = {};

    if (options && Object.keys(options).length) {
        answerKey = options.answerKey;
    }

    return answerKey;
}

export const getScoreForAnswer = (selectedAnswer, answerDetails) => {
    console.log('first',selectedAnswer)
    // let selected = getAnswerFromSelected(selectedAnswer);
    
    // let {options} = answerDetails, 
    //     answerLabels = {}, marks = 0;

    // if (options && Object.keys(options).length) {
    //     answerLabels = options.answerLabels;
    //     marks = options.marks;
    // }
    // if (Array.isArray(selected) && selected.length) {
    //     selected = selected[0]
    // }

    // // For MCQ, MSQ
    // if (selected.label && answerLabels.includes(selected.label)) {
    //     return marks;
    // }

    // // For FIB
    // if (Object.values(selectedAnswer).length && answerLabels) {
    //     let ans = Object.values(selectedAnswer)[0];
    //     if (Array.isArray(ans)) {
    //         ans = ans.join('');
    //     }
    //     let exists = answerLabels.find(e => String(e).toLowerCase() == String(ans).toLowerCase())

    //     if (exists) {
    //         return marks;
    //     }
    // }

    // if (Object.values(selectedAnswer).length && options.MTFLHS?.length) {
    //     let left = options?.MTFLHS;
    //     let right = options?.MTFRHS;

    //     let evaluated = evaluateMTF(left, right, selectedAnswer, getMarks(answerDetails));

    //     return evaluated.score;
    // }

    // return 0;
    console.log('first', selectedAnswer)
    let selected = getAnswerFromSelected(selectedAnswer);
    
    let {options} = answerDetails, 
        answerLabels = null, marks = 0;

    if (options && Object.keys(options).length) {
        answerLabels = options.answerLabels;
        marks = options.marks;
    }
    
    if (Array.isArray(selected) && selected.length) {
        selected = selected[0]
    }

    // For MCQ, MSQ - Add null check
    if (selected && selected.label && answerLabels && Array.isArray(answerLabels) && answerLabels.includes(selected.label)) {
        return marks;
    }

    // For FIB - Add null check
    if (Object.values(selectedAnswer).length && answerLabels && Array.isArray(answerLabels)) {
        let ans = Object.values(selectedAnswer)[0];
        if (Array.isArray(ans)) {
            ans = ans.join('');
        }
        let exists = answerLabels.find(e => String(e).toLowerCase() == String(ans).toLowerCase())

        if (exists) {
            return marks;
        }
    }

    if (Object.values(selectedAnswer).length && options && options.MTFLHS?.length) {
        let left = options?.MTFLHS;
        let right = options?.MTFRHS;

        let evaluated = evaluateMTF(left, right, selectedAnswer, getMarks(answerDetails));

        return evaluated.score;
    }

    return 0;
}

export const getMarks = (answerDetails) =>  {
    let {options} = answerDetails;
    return options.marks;
}

export const gradeAssessment = (gradingModel={}, obtainedScore=0, passingGrade='') => {
    let gradingModelDetails = gradingModel.details || [];
    // console.log('gradingModelDetails', gradingModelDetails);
    let name = '', passed = false,
        //  Locate grades within the grades array, which represents all possible grades from the grading model.
        grades = gradingModelDetails.map(e => e.gradeName);

    for (let index = 0; index < gradingModelDetails.length; index++) {
        const gradeDetail = gradingModelDetails[index];
        let {min, max, gradeName} = gradeDetail;

        if (Number(min) <= obtainedScore && Number(max) >= obtainedScore) {
            name = gradeName;
            break;
        }
    }

    /**
     * @author Shawan Mandal <github@imshawan.dev>
     * @description We are verifying the presence of both the passing grade and the obtained grade within the grades array. 
     * It then compares their respective positions in the array to determine if the obtained grade is at least equivalent to the passing grade. 
     * If this condition holds true, the variable passed is assigned true, indicating that the student has achieved a grade that meets or exceeds the required standard for passing in the grading system provided (simply meaning he/she passed the test).
     * 
     */
    let _passing = grades.findIndex(e => e == passingGrade);
    let _obtained = grades.findIndex(e => e == name);

    // will be used in the activity-analyser module to add up the rewarded score
    let activityScore = 0;
    let grade = gradingModelDetails.find(e => e.gradeName == name);

    if (grade && grade.activityScore) {
        activityScore = grade.activityScore;
    }

    if ((_passing !== -1 && _obtained !== -1) && _obtained <= _passing) {
        passed = true;
    }

    return {
        grade: name, passed, activityScore,
    }
}

/**
 * Build the `gradingResult` object from an evaluation result. Single source of truth
 * shared by the result page (Complete.jsx) and the early persist/rehydrate path
 * (Assessment.jsx), so the score persisted on evaluation-complete matches what the
 * result page displays.
 */
export const computeAssessmentGrading = ({ quizDetails = {}, evaluationResult = {}, endTime, endedAt }) => {
    const obtainedScore = evaluationResult?.marksSecured || 0;
    const total = evaluationResult?.totalMarks;
    const status = gradeAssessment(quizDetails.gradingModel, obtainedScore, quizDetails.passGrade);
    const percentage = total ? Math.round((obtainedScore / total) * 100) : 0;

    return {
        ...status, // grade, passed, activityScore
        timeTaken: endTime,
        scored: obtainedScore,
        total,
        endedAt,
        percentage,
    };
}